import React, { useEffect } from 'react'
import BTable from 'react-bootstrap/Table'
import { useTable, usePagination, useRowSelect, useSortBy } from 'react-table'
import { Pagination } from './Pagination'

import './table.scss'

export const Table = ({ columns, data, sorting, ...props }) => {
  const { 
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, selectedRowIds },
  } = useTable({
    columns,
    data,
    initialState: {
      pageIndex: 0,
      sortBy: sorting ? sorting : []
    },
  }, useSortBy, usePagination, useRowSelect, hooks => {
    if (props.hasOwnProperty('onSelectRow') && props.onSelectRow) {
      hooks.visibleColumns.push(columns => [
        {
          id: 'selection',
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <input type="checkbox" {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]) 
    }
  })

  useEffect(() => {
    if (props.hasOwnProperty('onSelectRow') && props.onSelectRow) {
      const selectedRowKeys = Object.keys(selectedRowIds)
      props.onSelectRow(selectedRowKeys.map(id => data[id]))
    }
  }, [selectedRowIds])

  return (
    <>
      <BTable striped bordered hover size="sm" {...props} {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </BTable>
      <Pagination
        gotoPage={gotoPage} 
        previousPage={previousPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageTotal={pageOptions.length}
        pageCount={pageCount}
      />
    </>
  )
}

export default Table